import React from 'react';
import { Link } from 'react-router-dom';
import Table from 'antd/lib/table';
import 'antd/lib/table/style/index.css';
import 'antd/lib/pagination/style/index.css';
import IconFlag from '../../components/utilities/IconFlag';
var tableStyles = require('src/imports/styles/extend.table.scss');
var ListAthlete = function (props) {
    props.athletes.sort(function (a, b) { return (a.name).localeCompare(b.name); });
    var columns = [{
            title: 'Athlete name',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
            width: 250,
            sorter: function (a, b) { return (a.name).localeCompare(b.name); },
            render: function (name, athlete) {
                return React.createElement(Link, { to: "/event/" + props.event.subdomain + "/athletes/" + athlete.id }, name);
            },
        }, {
            title: 'Category',
            dataIndex: 'categoryId',
            key: 'categoryId',
            render: function (categoryId) {
                var category = props.categories.find(function (c) { return c.id === categoryId; });
                return category ? category.name : '???';
            },
        }, {
            title: 'Gender',
            dataIndex: 'gender',
            key: 'gender',
            width: 100,
            className: tableStyles.colCenter,
            render: function (gender) { return (!gender
                ? '-'
                : gender.toLowerCase() === 'female'
                    ? 'F'
                    : gender.toLowerCase() === 'male'
                        ? 'M'
                        : '?'); },
        }, {
            title: 'Affiliations',
            dataIndex: 'affiliation',
            key: 'affiliation',
            render: function (affiliation) { return (affiliation
                ? affiliation
                : '-'); },
        }, {
            title: 'Country',
            dataIndex: 'countryCode',
            key: 'countryCode',
            className: tableStyles.colCenter,
            render: function (countryCode, athlete) { return (countryCode || athlete.countryState
                ? (React.createElement(React.Fragment, null,
                    countryCode ? React.createElement(IconFlag, { code: countryCode.toLowerCase() }) : '–',
                    " ",
                    athlete.countryState))
                : '–'); },
        }, {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: function (email) { return (email
                ? email
                : '–'); },
        }, {
            title: 'Identifier',
            dataIndex: 'identifier',
            key: 'identifier',
            render: function (identifier) { return (identifier
                ? identifier
                : '-'); },
        }];
    return (React.createElement(Table, { rowKey: 'id', columns: columns, dataSource: props.athletes, locale: { emptyText: 'No athletes in event' }, scroll: { x: 1280 }, pagination: { pageSize: 50 } }));
};
export default ListAthlete;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListAthletePage/ListAthlete.tsx
// module id = 1095
// module chunks = 0